module.exports = __webpack_public_path__ + "img/cross-icon-mobile.437f4d1d.svg";